import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  deleteDocument,
  fetchTypes,
  filterDocument,
  getAllDocuments,
  getDocuments,
  uploadDocument,
  viewDocuments,
} from "../api";
import { Constant } from "../lib/Constants";
import {
  DOCUMENT_DELETE_ERROR,
  DOCUMENT_DELETE_SUCCESS,
  DOCUMENT_FILTER_ERROR,
  DOCUMENT_FILTER_SUCCESS,
  DOCUMENT_TYPES_FETCH_ERROR,
  DOCUMENT_TYPES_FETCH_LOADING,
  DOCUMENT_TYPES_FETCH_SUCCESS,
  DOCUMENT_UPLOAD_ERROR,
  DOCUMENT_UPLOAD_LOADING,
  DOCUMENT_UPLOAD_SUCCESS,
  DOCUMENTS_FETCH_ERROR,
  DOCUMENTS_FETCH_LOADING,
  DOCUMENTS_FETCH_SUCCESS,
  USER_DOCUMENT_FETCH_ERROR,
  USER_DOCUMENT_FETCH_LOADING,
  USER_DOCUMENT_FETCH_SUCCESS,
  VIEW_DOCUMENT_ERROR,
  VIEW_DOCUMENT_LOADING,
  VIEW_DOCUMENT_SUCCESS,
} from "src/redux/types";

function* documentTypesFetch() {
  yield put({
    type: DOCUMENT_TYPES_FETCH_LOADING,
    payload: true,
  });
  try {
    let res = yield call(fetchTypes);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: DOCUMENT_TYPES_FETCH_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: DOCUMENT_TYPES_FETCH_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}

function* alldocumentFetch() {
  yield put({
    type: DOCUMENTS_FETCH_LOADING,
    payload: true,
  });
  try {
    let res = yield call(getAllDocuments);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: DOCUMENTS_FETCH_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: DOCUMENTS_FETCH_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}
function* getFilterDocuments(action) {
  // console.log(action.payload);
  try {
    // console.log('done')
    let res = yield call(filterDocument, action.payload);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: DOCUMENT_FILTER_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: DOCUMENT_FILTER_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    // console.log(error);
    // yield put({
    //   type: LEAVES_UPDATE_ERROR,
    //   payload: error.toString(),
    // });
  }
}
function* documentGet() {
  // console.log(action.payload);
  yield put({
    type: USER_DOCUMENT_FETCH_LOADING,
    payload: true,
  });
  try {
    let res = yield call(getDocuments);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: USER_DOCUMENT_FETCH_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: USER_DOCUMENT_FETCH_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    // console.log(error);
    // yield put({
    //   type: LEAVE_GET_ERROR,
    //   payload: error.toString(),
    // });
  }
}
function* documentUpload(action) {
  yield put({
    type: DOCUMENT_UPLOAD_LOADING,
    payload: true,
  });
  try {
    let res = yield call(uploadDocument, action.payload);
    let response = res.response.data;
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      yield put({
        type: DOCUMENT_UPLOAD_SUCCESS,
        payload: response.result,
      });
    } else {
      yield put({
        type: DOCUMENT_UPLOAD_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    console.log(error);
  }
}
function* viewDocument(action) {
  yield put({
    type: VIEW_DOCUMENT_LOADING,
    payload: true,
  });
  try {
    let res = yield call(viewDocuments, action.payload);
    let response = res.response.data;  
    if (res?.response?.status !== 404 && res?.response?.status === 200 && res.response.data) {
      yield put({
        type: VIEW_DOCUMENT_SUCCESS,
        payload: response,
      });
    } else {
        const errorMessage =
        res?.response?.data?.message ||
        "Failed to fetch document.";
      yield put({
        type: VIEW_DOCUMENT_ERROR,
        payload: errorMessage,
      });
    }
  } catch (error) {
    console.log(error);
  }
}
function* documentDelete(action) {
  // console.log(action.payload);

  try {
    let res = yield call(deleteDocument, action.payload);
    let response = res.response.data;
    // console.log(response.message);
    if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
      // console.log(response.message);
      yield put({
        type: DOCUMENT_DELETE_SUCCESS,
        payload: response.message,
      });
    } else {
      yield put({
        type: DOCUMENT_DELETE_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    // console.log(error);
    // yield put({
    //   type: LEAVES_DELETE_ERROR,
    //   payload: error.toString(),
    // });
  }
}
export function* documentSaga() {
  yield takeEvery("DOCUMENT_TYPES_FETCH_ACTION", documentTypesFetch);
  yield takeLatest("DOCUMENT_UPLOAD_ACTION", documentUpload);
  yield takeLatest("DOCUMENTS_FETCH_ACTION", alldocumentFetch);
  yield takeLatest("DOCUMENT_DELETE_ACTION", documentDelete);
  yield takeLatest("USER_DOCUMENT_FETCH_ACTION", documentGet);
  yield takeLatest("DOCUMENT_FILTER_ACTION", getFilterDocuments);
  yield takeLatest("VIEW_DOCUMENT_ACTION", viewDocument);
}
